import { Component, OnInit, ElementRef, Inject, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CoursesService } from '../../providers/courses.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '../../providers/app.config';
import { DomSanitizer } from '@angular/platform-browser';
import { LOCAL_STORAGE, WINDOW } from '@ng-toolkit/universal';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/providers/dashboard.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOCUMENT } from '@angular/common';
import { CartService } from 'src/providers/cart.service';
import { SkillsService } from 'src/providers/skills.service';

declare var $: any;
export interface videoData {
  video: any;
  type: string;
  viewtype:any;
}



@Component({
  selector: 'videoplayer-home',
  templateUrl: './videoplayer.html',
  styleUrls: ['./home.component.scss']
})
export class VideoPlayerDialog {

  video;
  type;

  constructor(public dialogRef: MatDialogRef<VideoPlayerDialog>, @Inject(MAT_DIALOG_DATA) public data: videoData,
    public sanitizer: DomSanitizer) {

    this.video = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.video);
    this.type = this.data.type;
  }

  close() {
    this.dialogRef.close()
  }


}


@Component({
  selector: 'new-course-home',
  templateUrl: './new-course.html',
  styleUrls: ['./home.component.scss']
})
export class NewCourseNotificationDialog {

  constructor(public dialogRef: MatDialogRef<NewCourseNotificationDialog>) { }

  close() {
    this.dialogRef.close()
  }

}


@Component({
  selector: 'app-neet-form',
  templateUrl: './neet-form.html',
  styleUrls: ['../ipmat/ipmat.component.scss']
})
export class NeetFormDialog {
  callBackForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  userData: any;
  token: any;
  constructor(public dialogRef: MatDialogRef<NeetFormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any, public deviceService: DeviceDetectorService,
  @Inject(DOCUMENT) public doc:any) {
    if (this.sessionStorage.getItem('userData')) {
      this.token = this.sessionStorage.getItem('usertoken')
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required]
    })
  }

  ngOnInit() {

    this.url = document.URL.split('/')[document.URL.split('/').length - 1];
    if (this.url == '') {
      this.page_loaction = 'Home'
    } else {
      this.page_loaction = this.url
    }
    if (this.url === 'cat-2024') {
      const closeTime = this.sessionStorage.getItem('dialogCloseTime');
      if (closeTime) {
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - parseInt(closeTime, 10);
        if (timeDiff < 24 * 60 * 60 * 1000) {
          this.dialogRef.close();
        }
      }
    }
  }

  callback() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: 'NEET',
        year: this.callBackForm.value.year,
        page_location: this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction
      }
      this.courseService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.addInternalCRMLead()
          this.addNPF()
          this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
          this.dialogRef.close(res)
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  addInternalCRMLead() {
    // if (this.token) {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "name": this.callBackForm.value.name,
        "firstName": this.callBackForm.value.name,
        "countryCode": 91,
        "phone": this.callBackForm.value.phone,
        "email": this.callBackForm.value.email,
        "source": "Website",
        "medium": 'NEET',
        "campaign": this.data,
        "pageLocation": 'NEET',
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        "customFields": {
          "exam": 'NEET',
          "examCategory": 'After 12th',
          "examTargetYear": this.callBackForm.value.year,
        "leadPriority": "Platinum",

        },
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "pageLocation": this.doc.URL,
            "source": "Website",
            "medium": 'NEET',
            "campaign": this.data,
            adContent: "",
    "ipAddress": this.sessionStorage.getItem('ipAddress'),
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {

        }
      })
    // }
  }

  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
            this.dialogRef.close(res)
          }
        })
      } else {
        this.callBackForm.reset()
        this.dialogRef.close(res)
      }
    })
  }

  close() {
    this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
    this.dialogRef.close()
  }

}









@Component({
  selector: 'app-skills-form',
  templateUrl: './skills-form.html',
  styleUrls: ['../ipmat/ipmat.component.scss']
})
export class SkillsFormDialog {
  callBackForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  userData: any;
  token:any;
  constructor(public dialogRef: MatDialogRef<SkillsFormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any, public deviceService: DeviceDetectorService,
  @Inject(DOCUMENT) public doc:any) {
    if (this.sessionStorage.getItem('userData')) {
      this.token = this.sessionStorage.getItem('usertoken')
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
    })
  }

  ngOnInit() {

    this.url = document.URL.split('/')[document.URL.split('/').length - 1];
    if (this.url == '') {
      this.page_loaction = 'Home'
    } else {
      this.page_loaction = this.url
    }
    if (this.url === 'cat-2024') {
      const closeTime = this.sessionStorage.getItem('dialogCloseTime');
      if (closeTime) {
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - parseInt(closeTime, 10);
        if (timeDiff < 24 * 60 * 60 * 1000) {
          this.dialogRef.close();
        }
      }
    }
  }

  callback() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: 'iSkills',
        page_location: this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction
      }
      this.courseService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.addInternalCRMLead()
          this.addNPF()
          this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
          this.dialogRef.close(res)
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  addInternalCRMLead() {
    if(this.token){
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": this.callBackForm.value.name,
        "firstName": this.callBackForm.value.name,
        "phone": this.callBackForm.value.phone,
        "email": this.callBackForm.value.email,
        "countryCode": 91,
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "registrationDate": new Date(this.userData.date_joined).valueOf(),
        "userId": this.userData ? this.userData.id : 9999,
        "source": "Website",
        "medium": "Skills Enquiry",
        "campaign": this.data,
        "pageLocation": this.doc.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        "customFields": {
          "exam": 'iSkills',
          "examCategory": 'iSkills',
          "examTargetYear": 2025,
        "leadPriority": "Platinum",

        },
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "pageLocation": this.doc.URL,
            "source": "Website",
            "medium": "Skills Enquiry",
            "campaign": this.data,
            adContent: "",
    "ipAddress": this.sessionStorage.getItem('ipAddress'),
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent
          },
        ],
      }
  
  
      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
  
        }
      })
    }
  }

  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
            this.dialogRef.close(res)
          }
        })
      } else {
        this.callBackForm.reset()
        this.dialogRef.close(res)
      }
    })
  }

  close() {
    this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
    this.dialogRef.close()
  }

}


@Component({
  selector: 'app-score-form',
  templateUrl: './score-form.html',
  styleUrls: ['../ipmat/ipmat.component.scss']
})
export class ScoreFormDialog {
  callBackForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  userData: any;
  token: any;
  bschoolsList:any[]=[];
  Counseling:any [] = [
    {
    "Name": "Global Institute of Business Studies (GIBS), Bangalore",
     "highestSalary": "16.15",
     "avgSalary": "7.40"
    },
    {
    "Name": "International School of Business & Research (ISBR), Bangalore",
     "highestSalary": "14.0",
     "avgSalary": "8.0"
    },
    {
    "Name": "International Institute of Business Studies (IIBS), Bangalore",
     "highestSalary": "14.0",
     "avgSalary": "8.0"
    },
    {
    "Name": "Alliance University, Bangalore",
     "highestSalary": "60.10",
     "avgSalary": "8.50"
    },
    {
    "Name": "Praxis Business School, Kolkata",
     "highestSalary": "12",
     "avgSalary": "8"
    },
    {
    "Name": "IQ City United World School of Business (UW), Kolkata",
     "highestSalary": "14",
     "avgSalary": "6"
    },
    {
    "Name": "Institute of Engineering & Management (IEM), Kolkata",
     "highestSalary": 6,
     "avgSalary": 36
    },
    {
    "Name": "Atlas Skilltech University, Mumbai",
     "highestSalary": "25",
     "avgSalary": "9"
    },
    {
    "Name": "Indian Institute of Education and Business Management (IIEBM), Pune",
     "highestSalary": "30",
     "avgSalary": "7.5"
    },
    {
    "Name": "International School Of Management Studies (ISMS), Pune",
     "highestSalary": "14",
     "avgSalary": "6"
    },
    {
    "Name": "University of Petroleum and Energy Studies (UPES), Dehradun",
     "highestSalary": "50.09",
     "avgSalary": "7.02"
    },
    {
    "Name": "Greater Noida Institute of Technology (GNIOT), Greater Noida",
     "highestSalary": "12.56",
     "avgSalary": "6.46"
    },
    {
    "Name": "Institute of Business Management & Research (IBMR), Gurgaon",
     "highestSalary": "15.0",
     "avgSalary": "9.4"
    },
    {
    "Name": "Institute of Integrated Learning in Management (IILM),Greater Noida",
     "highestSalary": "18",
     "avgSalary": "8"
    },
    {
    "Name": "Institute of Integrated Learning in Management (IILM), Gurgaon",
     "highestSalary": "20",
     "avgSalary": "8.6"
    },
    {
    "Name": "Fostiima Business School,New Delhi",
     "highestSalary": "25",
     "avgSalary": "10.76"
    },
    {
    "Name": "Jaipuria institute of Management (JIM), Noida",
     "highestSalary": "22",
     "avgSalary": "11.08"
    },
    {
    "Name": "Jaipuria Institute of Management (JIM), Lucknow",
     "highestSalary": "22",
     "avgSalary": "9.05"
    },
    {
    "Name": "Apeejay school of Management (ASM), Dwarka",
     "highestSalary": "20",
     "avgSalary": "8.47"
    },
    {
    "Name": "Siva Sivani Institute of Management (SSIM), Hyderabad",
     "highestSalary": "17.5",
     "avgSalary": "7.50"
    },
    {
    "Name": "Woxsen University, Hyderabad",
     "highestSalary": "19",
     "avgSalary": "9.04"
    },
    {
    "Name": "Taxila Business School (Taxila), JAIPUR",
     "highestSalary": "28.6",
     "avgSalary": "11.5"
    },
    {
    "Name": "Swami Vivekanand Institute of Management and Coumputer Science (SVIMCS), Kolkata",
     "highestSalary": "10",
     "avgSalary": "5 - 6"
    },
    {
    "Name": "Pune Institute of Business Management (PIBM), Pune",
     "highestSalary": "18",
     "avgSalary": "9.5"
    },
    {
    "Name": "ASM’s Institute of Business Management and Research (IBMR), Pune",
     "highestSalary": "16",
     "avgSalary": "6.5"
    },
    {
    "Name": "Akemi Business School , Pune",
     "highestSalary": "18",
     "avgSalary": "6.87"
    },
    {
    "Name": "Shanti Business School (SBS), Amhedabad",
     "highestSalary": "16.12",
     "avgSalary": "8.65"
    },
    {
    "Name": "International School of Management Excellence (ISME), Bangalore",
     "highestSalary": "14.0",
     "avgSalary": "7.50"
    },
    {
    "Name": "Indus Business Academy (IBA), Bangalore",
     "highestSalary": "22.26",
     "avgSalary": "7.80"
    },
    {
    "Name": "Regional College of Management (RCM), Bangalore",
     "highestSalary": "44.0",
     "avgSalary": "8.50"
    },
    {
    "Name": "Krupanidhi college of Management (KCM), Bangalore",
     "highestSalary": "24.00",
     "avgSalary": "8.67"
    },
    {
    "Name": "Institute of Finance and International Management (IFIM) Bangalore",
     "highestSalary": "15.0",
     "avgSalary": "7.50"
    },
    {
    "Name": "Kirloskar Institute Of Advanced Management Studies (KIAMS), Harihar Bangalore",
     "highestSalary": "18.00",
     "avgSalary": "8.50"
    },
    {
    "Name": "Acharya Bangalore B-School (ABBS), Bangalore",
     "highestSalary": "22.50",
     "avgSalary": "7.50"
    },
    {
    "Name": "Soundarya Institute of Management & Science (SIMS), Bangalore",
     "highestSalary": "5.60",
     "avgSalary": "2.64"
    },
    {
    "Name": "Ramaiah Institute of Management Studies and Sciences (RIMS), Bangalore",
     "highestSalary": "10.08",
     "avgSalary": "6.48"
    },
    {
    "Name": "Sandip University, Sijoul Bihar",
     "highestSalary": "5",
     "avgSalary": "2"
    },
    {
    "Name": "Firebird Institute of Research in Management (FIRM), Coimbatore, Chennai",
     "highestSalary": "13.98",
     "avgSalary": "6.0"
    },
    {
    "Name": "Doon Business School (DBS), Dehrahun",
     "highestSalary": "23.50",
     "avgSalary": "8.75"
    },
    {
    "Name": "LLOYD Business School, Greater Noida",
     "highestSalary": "24.80",
     "avgSalary": "6.58"
    },
    {
    "Name": "G L Bajaj Institute Of Management & Research (GLBIMR), Greater Noida",
     "highestSalary": "12.00",
     "avgSalary": "8.50"
    },
    {
    "Name": "BML Munjal university, Gurgaon",
     "highestSalary": "25.9",
     "avgSalary": "8.0"
    },
    {
    "Name": "BML Munjal university, Gurgaon",
     "highestSalary": "25.9",
     "avgSalary": "8.0"
    },
    {
    "Name": "Asian Business School (ABS), Noida",
     "highestSalary": "29.0",
     "avgSalary": "7.50"
    },
    {
    "Name": "J K Business School (JKBS), Gurugram New Delhi",
     "highestSalary": "24.0",
     "avgSalary": "7.0"
    },
    {
    "Name": "Institute of Technology and Science (ITS), Gaziabaad",
     "highestSalary": "18.50",
     "avgSalary": "5.65"
    },
    {
    "Name": "Jaipuria institute of Management (JIM), Ghaziabad",
     "highestSalary": "12.4",
     "avgSalary": "5.5"
    },
    {
    "Name": "Institute of Integrated Learning in Management (IILM), Lodhi Road New Delhi",
     "highestSalary": "14",
     "avgSalary": "6.5"
    },
    {
    "Name": "New Delhi Institute of Management (NDIM), New Delhi",
     "highestSalary": "12",
     "avgSalary": "10"
    },
    {
    "Name": "Fortune Institute of International Business (FIIB), New Delhi",
     "highestSalary": "25",
     "avgSalary": "8.5"
    },
    {
    "Name": "Asia Pasific institute of management (APIM), New Delhi",
     "highestSalary": "22",
     "avgSalary": "8.11"
    },
    {
    "Name": "Entrepreneurship and Management Processes International Business School (EMPI), New Delhi",
     "highestSalary": "20",
     "avgSalary": "8.5"
    },
    {
    "Name": "Shoolini University, Solan",
     "highestSalary": "42",
     "avgSalary": "6.5"
    },
    {
    "Name": "Vignana Jyothi Institute Of Management\n (VJIM), Hyderabad",
     "highestSalary": "34",
     "avgSalary": "8.3"
    },
    {
    "Name": "Vishwa Vishwani Institute Of Management, Hyderabad",
     "highestSalary": "10",
     "avgSalary": "6"
    },
    {
    "Name": "Prestige University, Indore",
     "highestSalary": "32",
     "avgSalary": "5"
    },
    {
    "Name": "Globsyn Business School (GBS), Kolkata",
     "highestSalary": "18.33",
     "avgSalary": "7.39"
    },
    {
    "Name": "Calcutta Business School (CBS) Kolkata",
     "highestSalary": "25",
     "avgSalary": "7.45 L - 7.96"
    },
    {
    "Name": "Bengal Institute of Business Studies (BIBS), Kolkata",
     "highestSalary": "13.5",
     "avgSalary": "6"
    },
    {
    "Name": "Eastern Institute for Integrated Learning in Management (EIILM), Kolkata",
     "highestSalary": "13.5",
     "avgSalary": "5.5"
    },
    {
    "Name": "NSHM Knowledge Campus, Kolkata",
     "highestSalary": "12",
     "avgSalary": "5.6"
    },
    {
    "Name": "St. Xavier Business School, Kolkata",
     "highestSalary": "12",
     "avgSalary": "7.5"
    },
    {
    "Name": "Management Development Institute ((MDIM), Murshidabad",
     "highestSalary": "21",
     "avgSalary": "11.76"
    },
    {
    "Name": "Brainware University, Kolkata",
     "highestSalary": "12",
     "avgSalary": "3.5 L +"
    },
    {
    "Name": "Adamas University, Kolkata",
     "avgSalary": "4.5"
    },
    {
    "Name": "Institute of Management Study (IMS), Kolkata",
     "highestSalary": "4.80",
     "avgSalary": "2.40"
    },
    {
    "Name": "IILM Acadmy of Higher Learning, Lucknow",
     "highestSalary": "10.8",
     "avgSalary": "6"
    },
    {
    "Name": "JS Kothari Business School, (JSKBS), Mumbai",
     "highestSalary": "14",
     "avgSalary": "6.5"
    },
    {
    "Name": "Universal Ai University (UBS), Mumbai",
     "highestSalary": "22",
     "avgSalary": "15.32"
    },
    {
    "Name": "Institute for Technology and Management (ITM), Navi Mumbai",
     "highestSalary": "21",
     "avgSalary": "8.65"
    },
    {
    "Name": "Uma Krishna Shetty Institute of Management Studies and Research (UKS), Mumbai",
     "highestSalary": "10.5",
     "avgSalary": "5.75"
    },
    {
    "Name": "MYRA Business School( MYRA), Mysore",
     "highestSalary": "13.5",
     "avgSalary": "8.46"
    },
    {
    "Name": "Sandip University, Nasik",
     "highestSalary": "12.5",
     "avgSalary": "4.5"
    },
    {
    "Name": "D Y Patil B School (DPU), Tathawade Pune",
     "highestSalary": "18",
     "avgSalary": "8.01"
    },
    {
    "Name": "Ramachandran International Institute Of Management (RIIM), Pune",
     "highestSalary": "13",
     "avgSalary": "5.95"
    },
    {
    "Name": "Lexicon MILE - Management Institute of Leadership and Excellence (MILE), Pune",
     "highestSalary": "19",
     "avgSalary": "8.27"
    },
    {
    "Name": "MITCON (MIMA), Pune",
     "highestSalary": "18",
     "avgSalary": "7.50"
    },
    {
    "Name": "Pune Business School (PBS) Pune",
     "highestSalary": "27",
     "avgSalary": "6.8"
    },
    {
    "Name": "Pimpri Chinchawad University (PCU), Pune",
     "highestSalary": "20",
     "avgSalary": "5.5"
    },
    {
    "Name": "Kirloskar Institute Of Advanced Management Studies (KIAMS), Pune",
     "highestSalary": "18",
     "avgSalary": "8.5"
    },
    {
    "Name": "Karnataka College of Management (KCM), Banglore",
     "highestSalary": "25",
     "avgSalary": "7.2"
    },
    {
    "Name": "SOIL Institute of Management, Gurugram",
     "highestSalary": "27",
     "avgSalary": "10.3"
    },
    {
    "Name": "DIT University, Dehradun",
     "highestSalary": 4.96,
     "avgSalary": 15
    },
    {
    "Name": "RIT (Roorkee Institute of Technology)",
     "highestSalary": 7.5,
     "avgSalary": 12
    }
   ]

   stateList:any[]=[];
   cityList:any[]=[]
  constructor(public dialogRef: MatDialogRef<ScoreFormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any, public deviceService: DeviceDetectorService,
  public catService: CartService, public skillsService: SkillsService) {
    if (this.sessionStorage.getItem('userData')) {
      this.token = this.sessionStorage.getItem('usertoken')
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      course: [this.data ? this.data.Name : ''],
      state:['', Validators.required],
      city:['', Validators.required]
    })
    if(!this.data){
      this.catService.getBSchools().subscribe(res=>{
        this.bschoolsList = res;
        this.bschoolsList = this.bschoolsList.concat(this.Counseling)
      })
    }
    this.getStates()
  }

  getStates(){
    this.skillsService.getStates().subscribe(res=>{
      this.stateList = res;
    })
  }

  getCities(){
    this.skillsService.getAllCities().subscribe(res=>{
      this.cityList = res.filter((x:any)=> x.state == this.callBackForm.value.state);
    })
  }

  ngOnInit() {

    this.url = document.URL.split('/')[document.URL.split('/').length - 1];
    if (this.url == '') {
      this.page_loaction = 'Home'
    } else {
      this.page_loaction = this.url
    }
    if (this.url === 'cat-2024') {
      const closeTime = this.sessionStorage.getItem('dialogCloseTime');
      if (closeTime) {
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - parseInt(closeTime, 10);
        if (timeDiff < 24 * 60 * 60 * 1000) {
          this.dialogRef.close();
        }
      }
    }
  }

  callback() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course,
        page_location: ''
      }
      this.courseService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          // if(this.callBackForm.value.course == 'LBSIM'){
            let reqObj = {
              "secret_key": "b51ce171399884e7a185aac280b59d69",
              "college_id": "247",
              "email": this.callBackForm.value.email,
              "mobile": this.callBackForm.value.phone,
              "state": this.callBackForm.value.state,
              "city": this.callBackForm.value.city,
              "source": "iquanta",
              "name": this.callBackForm.value.name,
              "isMeritto": this.callBackForm.value.course == 'LBSIM' ? true : false,
            }
        
            this.courseService.addCollegeLead(reqObj).subscribe(res => {
              // this.dialogRef.close(res)
            })
          // }
          
          this.dialogRef.close(res)
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  addInternalCRMLead() {
    if (this.token) {
      let medium: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "firstName": this.callBackForm.value.name,
        "lastName": '',
        "phone": this.callBackForm.value.phone,
        "email": this.callBackForm.value.email,
        "countryCode": 91,
        "source": "Blog",
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData.id,
        "registrationDate": new Date(this.userData.date_joined).valueOf(),
        "leadActivity": "Free Counselling",
        "primaryRegistrationCampaign": "Blog_name",
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? medium : this.page_loaction,
        "registrationDevice": this.deviceService.deviceType,
        "primaryTrafficChannel": "Free Counselling",
        "leadOriginPrimary": "API",
        "customFields": {
          "course": this.callBackForm.value.course
        },

      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {

        }
      })
    }
  }

  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.page_loaction + '?' + this.sessionStorage.getItem('utmLink') : this.page_loaction

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
            this.dialogRef.close(res)
          }
        })
      } else {
        this.callBackForm.reset()
        this.dialogRef.close(res)
      }
    })
  }

  close() {
    this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
    this.dialogRef.close()
  }

}
